import { Pipe, PipeTransform } from '@angular/core';
import { NgDateFormats } from '../../../../globals';
import { SessionEnvironment, SessionModel } from '../../../../modules/instructor-led-trainings/models/session.model';
import { LocalizedDatePipe } from '../../../pipes/localized-date/localized-date-pipe.pipe';
import { PageService } from '../../../services';
import { ISessionCardData, ISessionCardState } from '../session-details-card.component';

@Pipe({
	name: 'sessionDetailsCard'
})
export class SessionDetailsCardPipe implements PipeTransform {
	constructor(
		private readonly pageService: PageService,
		private readonly localizedDatePipe: LocalizedDatePipe
	) {}

	transform(sessionDetails: SessionModel | any): Partial<ISessionCardData> {
		const { start_time, timezone, end_time, max_capacity, location_title, location } = sessionDetails;
		const month = this.localizedDatePipe.transform(start_time, 'MMM');
		const day = this.localizedDatePipe.transform(start_time, 'dd');
		const year = this.localizedDatePipe.transform(start_time, 'YYYY');
		const isWebinar = sessionDetails.environment_type !== SessionEnvironment.in_person;
		const time_interval =
			this.localizedDatePipe.transform(start_time, NgDateFormats.DATE_AND_TIME) +
			' - ' +
			this.localizedDatePipe.transform(end_time, NgDateFormats.DATE_AND_TIME) +
			' ' +
			timezone;
		let seats_available = this.pageService.translateService.instant('lup.live_trainings.capacity.unlimited');
		if (sessionDetails.hasOwnProperty('num_enrolled') && max_capacity) {
			const seatsNumber = max_capacity - sessionDetails.num_enrolled;
			const pluralKey = seatsNumber === 1 ? 'singular' : 'plural';
			seats_available = this.pageService.translateService.instant('lup.catalog.seats_available.' + pluralKey, {
				number_of_seats: seatsNumber
			});
		}
		return {
			month,
			day,
			year,
			isWebinar,
			seats_available,
			time_interval,
			location_title,
			location,
			class: ISessionCardState.DEFAULT // extend logic once we do have session status (add state classes)
		};
	}
}
